/** Из поля ввода или URL профиля извлекает slug пользователя. */
export function parseUserSlugInput(raw: string): string {
  const trimmed = raw.trim()
  if (trimmed === '') return ''

  try {
    if (trimmed.includes('://') || trimmed.startsWith('/')) {
      const url = trimmed.startsWith('/') ? `https://example.local${trimmed}` : trimmed
      const parsed = new URL(url)
      const match = parsed.pathname.match(/\/users\/([^/?#]+)/i)
      if (match?.[1]) {
        return decodeURIComponent(match[1]).trim()
      }
    }
  } catch {
    // not a URL — treat as slug
  }

  return trimmed.replace(/^@+/, '').trim()
}

export function formatRestrictionUserLabel(user: {
  id?: number | null
  slug?: string | null
  fullname?: string | null
  shortname?: string | null
}): string {
  const name = (user.fullname ?? user.shortname ?? '').trim()
  if (name.length > 0) return name
  if (user.slug) return `@${user.slug}`
  if (user.id) return `ID ${user.id}`
  return 'Пользователь'
}

export function formatRestrictionUserSlug(user: { slug?: string | null }): string | null {
  const slug = typeof user.slug === 'string' ? user.slug.trim() : ''
  return slug.length > 0 ? `@${slug}` : null
}

export type SelectedRestrictionUser = {
  id: number
  slug?: string | null
  fullname?: string | null
  shortname?: string | null
  avatar?: string | null
}

/** Candidate shape expected by presentational RestrictionUserPicker. */
export type RestrictionUserCandidate = {
  id: number
  slug?: string | null
  fullname?: string | null
  shortname?: string | null
  avatar?: string | null
  restrictable: boolean
  restrictable_reason?: string | null
}

export function mapCandidateToSelectedUser(user: {
  id?: number | null
  slug?: string | null
  fullname?: string | null
  shortname?: string | null
  avatar?: string | null
}): SelectedRestrictionUser | null {
  const id = Number(user.id)
  if (!Number.isSafeInteger(id) || id <= 0) return null
  return {
    id,
    slug: user.slug ?? null,
    fullname: user.fullname ?? null,
    shortname: user.shortname ?? null,
    avatar: user.avatar ?? null,
  }
}

export function mapResolvedUserToSelected(user: {
  id: number | null
  deleted?: boolean
  slug?: string | null
  fullname?: string | null
  shortname?: string | null
  avatar?: string | null
}): SelectedRestrictionUser | null {
  if (user.deleted || user.id == null) {
    return null
  }

  return {
    id: user.id,
    slug: user.slug ?? null,
    fullname: user.fullname ?? null,
    shortname: user.shortname ?? null,
    avatar: user.avatar ?? null,
  }
}
